var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCd = function SvgCd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cd_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-88h600v600H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd_svg__a)",
    transform: "translate(0 75.1)scale(.853)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007fff",
    d: "M0-88h800v600H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7d618",
    d: "M36 32h84l26-84 26 84h84l-68 52 26 84-68-52-68 52 26-84zM750-88 0 362v150h50L800 62V-88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1021",
    d: "M800-88 0 392v120L800 32z"
  }))));
};
export default SvgCd;